<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Consulta de Logs.</span>
                <br />
                <span class="navigation">Relatório > Consulta Logs</span>
              </h4>
            </div>
          </div>
        </div>

        <div class="card-body">
          <error-list :erros="erros" />
          <div class="row">
            <div class="col-md-2 col-lg-2 mb-1">
              <label for="dataIni">Data Inicial: *</label>
            </div>
            <div class="col-md-2 col-lg-2 mb-1">
              <label for="dataFim">Data Final: *</label>
            </div>
            <div class="col-md-6 col-lg-6 mb-1">
              <label for="dataIni">Contribuinte:</label>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar id="dataIni" name="dataIni" v-model="dataIni" :showIcon="true" dateFormat="dd/mm/yy"
                  placeholder="Data Inicial" v-maska="'##/##/####'" />
              </span>
            </div>

            <div class="col-md-2 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar id="dataFim" name="dataFim" v-model="dataFin" :showIcon="true" dateFormat="dd/mm/yy"
                  placeholder="Data Final" v-maska="'##/##/####'" />
              </span>
            </div>
            <div class="col-md-6 col-lg-6 mb-3">
              <span class="p-fluid">
                <AutoComplete id="tomador" v-model="selectedContribuinte" :dropdown="true"
                    :suggestions="filteredContribuintes" @complete="searchContribuintes($event)"
                    @keyup.enter="pesquisar" field="detail" placeholder="CPF/CNPJ/Nome/Inscrição Contribuinte" />
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 col-lg-2 mb-3">
              <Button 
                class="btn btn-primary"
                type="button"
                icon="pi pi-print"
                label="Imprimir"
                title="Imprimir"
                :disabled="loading"
                @click="imprimirConsultaLogs()"
              ></Button>
            </div>
          </div>

          <div style="height:45vh"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginService from "../services/acesso/login.service";
import ReportService from "../services/report.service";
import CustomCalendar from "../components/global/CustomCalendar.vue";
import PessoaService from "../services/tributario/contribuinte.cadastro.service";

export default {
  name: "RelatorioConsultaLogs",

  components: {
    CustomCalendar
  },
  data() {
    return {
      erros: [],
      loading: null,
      dataIni: null,
      dataFin: null,
      competenciaLimite: null,
      currentUser: null,
      filteredContribuintes: null,
      selectedContribuinte: null,
      baseURLSistema: null
    };
  },
   mounted() {
    document.getElementById("dataIni").focus();
  },
  created() {
    this.baseURLSistema = (this.$baseURLSistema ? this.$baseURLSistema : null);
    this.currentUser = LoginService.currentUserValue;
    this.dataIni = new Date();
    this.dataIni.setDate(this.dataIni.getDate()-30);
    this.dataFin = new Date();
  },
  methods: {
    imprimirConsultaLogs() {
      let msg = null;

      if (!this.dataIni) {
        msg = "É necessário informar a data inicial!";
      } else if (!this.dataFin) {
        msg = "É necessário informar a data final!";
      } else {
        const ini = new Date(this.dataIni);
        const fin = new Date(this.dataFin);

        const diffTime = fin - ini;
        const diffDays = diffTime / (1000 * 60 * 60 * 24);

        if (diffDays > 30) {
          msg = "O período entre as datas não pode ser superior a 30 dias!";
        } else if (diffDays < 0) {
          msg = "A data final não pode ser anterior à data inicial!";
        }
      }

      if (!msg) {
        this.processando(true);
        ReportService.imprimir("ConsultaLogs", [
          {
            param: "ID_CLIENTE",
            string: this.currentUser.usuario.idCliente
          },
          {
            param: "ID_CONTRIBUINTE",
            string: this.selectedContribuinte && this.selectedContribuinte.id ? this.selectedContribuinte.id : null
          },
          {
            param: "where",
            string: this.selectedContribuinte && this.selectedContribuinte.id ? ' where log.id_cliente = $P{ID_CLIENTE} and cast(log.data_log as date) BETWEEN $P{DATA_INICIAL} and $P{DATA_FINAL} and log_contr.conteudo_atual = $P{ID_CONTRIBUINTE}' 
            : 'where log.id_cliente = $P{ID_CLIENTE} and cast(log.data_log as date) BETWEEN $P{DATA_INICIAL} and $P{DATA_FINAL}'
          },
          {
            param: "DATA_INICIAL",
            date: this.dataIni
          },
          {
            param: "DATA_FINAL",
            date: this.dataFin
          },
          {
            param: "URL_RELATORIO",
            string: this.baseURLSistema 
          }
        ])
          .then(
            () => {},
            error => {
              this.$root.$emit("alert:warn", "Erro ao Imprimir!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },
    searchContribuintes(event) {
      setTimeout(async () => {
          let idContr = this.currentUser.contribuinte.idContribuinte;
          this.filteredContribuintes = await PessoaService.comboByContribuinteFiltro(
              this.currentUser.usuario.idCliente,
              idContr,
              event.query
          );
      }, 550);
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  },
  computed: {}
};
</script>

<style scoped>
</style>